import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import styles from "./Tabs.module.scss";

class Tab extends PureComponent {
  static propTypes = {
    activeTab: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.onClickTabItem = this.onClickTabItem.bind(this);
  }

  onClickTabItem() {
    const { onClick, indexTab } = this.props;
    onClick(indexTab);
  }

  render() {
    const { activeTab, indexTab, label, icon, width, alertTabs } = this.props;
    // alertTabs holds 1-based tab positions as strings.
    const hasAlert = !!alertTabs && alertTabs.includes(String(indexTab + 1));

    return (
      <li
        className={classnames(
          styles["tab-list-item"],
          activeTab === indexTab ? styles["tab-list-active"] : ""
        )}
        onClick={this.onClickTabItem}
        style={{ width: width ? width + "%" : "auto" }}
      >
        <div>
          {icon ? <img src={icon} alt={label} /> : null}
          <span
            className={classnames(
              styles["tab-btn"],
              hasAlert ? styles["tab-alert-label"] : ""
            )}
          >
            {label}
          </span>
          {hasAlert ? (
            <i
              className={classnames(
                "icon-ttp-alert-circle",
                "tab-list-alert",
                styles["tab-alert-icon"]
              )}
            ></i>
          ) : (
            ""
          )}
        </div>
      </li>
    );
  }
}

export default Tab;
